import { render, staticRenderFns } from "./MemberPersonalInfo.vue?vue&type=template&id=3dafb859&"
import script from "./MemberPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./MemberPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports